module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Buerglen_UR-24f1dfc2b5fba504980144dd50a03331.svg";